import supabaseClient from "./supabase";

const AUTH_TOKEN_KEY = "auth_token";
const VOTE_COUNT_KEY = "vote_count";

export const getSupabaseToken = async (): Promise<string | null> => {
  const { data } = await supabaseClient.auth.getSession();
  return data.session?.access_token || null;
};

export const getAuthHeaders = async (): Promise<Record<string, string>> => {
  const token = await getSupabaseToken();
  if (!token) {
    return {};
  }
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
};

export const generateMockJwt = (code: string): string => {
  const header = btoa(JSON.stringify({ alg: "HS256", typ: "JWT" }));
  const payload = btoa(
    JSON.stringify({
      sub: "12345",
      name: "Mock User",
      email: "user@example.com",
      iat: Math.floor(Date.now() / 1000),
      exp: Math.floor(Date.now() / 1000) + 60 * 60,
    })
  );
  const signature = btoa("mockSignature");

  return `${header}.${payload}.${signature}`;
};

export const saveAuthToken = (token: string): void => {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
};


export const getAuthToken = (): string | null => {
  return localStorage.getItem(AUTH_TOKEN_KEY);
};

export const isAuthenticated = async (): Promise<boolean> => {
  const { data } = await supabaseClient.auth.getSession();
  return !!data.session;
};

export const getVoteCount = (): number => {
  const count = localStorage.getItem(VOTE_COUNT_KEY);
  return count ? parseInt(count, 10) : 0;
};


export const incrementVoteCount = (): number => {
  const currentCount = getVoteCount();
  const newCount = currentCount + 1;
  localStorage.setItem(VOTE_COUNT_KEY, newCount.toString());
  return newCount;
};

export const hasEnoughVotes = (requiredVotes: number = 10): boolean => {
  return getVoteCount() >= requiredVotes;
};
